module.exports = __webpack_public_path__ + "static/media/tbg.42144f14.png";